import * as React from "react";
import { BaseIconProps } from "../Shared/SharedData";

export interface XingIconProps extends BaseIconProps {}

const XingIcon: React.FunctionComponent<XingIconProps> = (props) => {
  return (
    <svg
      width={props.size ?? "97"}
      height={props.size ?? "97"}
      style={props.style}
      className={props.className}
      viewBox="0 0 384 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill={props.color}>
        <path d="M162.7 210c-1.8 3.3-25.2 44.4-70.1 123.5-4.9 8.3-10.8 12.5-17.7 12.5H9.8c-7.7 0-12.1-7.5-8.5-14.4l69-121.3c.2 0 .2-.1 0-.3l-43.9-75.6c-4.3-7.8.3-14.1 8.5-14.1H100c7.3 0 13.3 4.1 18 12.2l44.7 77.5zM382.6 46.1l-144 253v.3L330.2 466c3.9 7.1.2 14.1-8.5 14.1h-65.2c-7.6 0-13.6-4-18-12.2l-92.4-168.5c3.3-5.8 51.5-90.8 144.8-255.2 4.6-8.1 10.4-12.2 17.5-12.2h65.7c8 0 12.3 6.7 8.5 14.1z" />
      </g>
    </svg>
  );
};

export default XingIcon;
